// extracted by mini-css-extract-plugin
module.exports = {"heading":"_3Ynwf2o7_SIr6VAwEAm3sp","body":"_2i90vgpM7rkHgBJzMC_KP2","closed":"-TF8TFBL1UOotKkdLyJRv"};